import pino from "pino";

export const logger = pino({
  browser: { asObject: true },
  enabled: process.env.NODE_ENV !== "production",
  level: process.env.NODE_ENV === "production" ? "silent" : "trace",
});
